export const gameId = "84449680-29e1-11eb-9dd5-d1bdf5046fdb";
export const streamLabel = "broadcast";
export const environment = "v4";
